import { useEffect, useState } from 'react';
import api, { assetUrl } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Heart } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const Favorites = () => {
  const [items, setItems] = useState([]);
  const { t } = useLanguage();
  useEffect(() => { api.get('/favorites').then(({ data }) => setItems(data)); }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="font-display text-3xl sm:text-4xl font-bold">{t('favorites.title', 'Favorites')}</h1>
      <p className="text-white/60 mt-1">{t('favorites.subtitle', 'Designs you love, always within reach.')}</p>

      {items.length === 0 ? (
        <div className="jw-card p-16 text-center mt-8">
          <Heart className="w-8 h-8 text-white/40 mx-auto" />
          <p className="text-white/60 mt-3">{t('favorites.empty', 'No favorites yet. Browse the design library and tap the heart icon.')}</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mt-8">
          {items.map(d => (
            <Card key={d.id} className="jw-card overflow-hidden">
              <div className="aspect-square bg-[color:var(--jw-navy-950)] overflow-hidden">
                <img src={assetUrl(d.image_url)} alt={d.name} className="w-full h-full object-cover" />
              </div>
              <div className="p-3">
                <p className="text-white text-sm font-semibold truncate">{d.name}</p>
                <p className="text-white/50 text-xs">{d.category ? t(`designCategory.${d.category}`, d.category.replace('_', ' ')) : ''}</p>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default Favorites;
